import { FormattedMessage } from 'react-intl';
import React from 'react';

const WalletNotificationImpulsColumns = [
  {
    id: 'idWalletNotificationImpuls',
    label: <FormattedMessage id={'app.idWalletNotificationImpuls'} />,
    width: '20%',
  },
  {
    id: 'date',
    label: <FormattedMessage id={'app.sentDate'} />,
    width: '30%',
  },
  {
    id: 'iosDevices',
    label: <FormattedMessage id={'app.devices.iosDevices'} />,
    width: '15%',
  },
  {
    id: 'androidDevices',
    label: <FormattedMessage id={'app.devices.androidDevices'} />,
    width: '15%',
  },
];
export default WalletNotificationImpulsColumns;
